// Types and constants local to the Ashtakvarga calculator widget.

export interface AshtakvargaRequest {
  name: string;
  birth_date: string;
  birth_time?: string | null;
  birth_place: string;
  latitude?: number | null;
  longitude?: number | null;
  timezone?: string | null;
}

export interface PredictionItem {
  house: number;
  house_name: string;
  sav: number;
  strength: "very_strong" | "average" | "below_average" | "weak";
  summary: string;
}

export interface AshtakvargaResponse {
  sarvashtakvarga_table: number[];
  sign_names: string[];
  planet_ashtakvarga_tables: Record<string, number[]>;
  planet_display_en: Record<string, string>;
  bindu_totals_per_house: number[];
  total_bindus: Record<string, number>;
  planet_strength: Record<string, string>;
  predictions: PredictionItem[];
}

export const LOADING_STEPS = [
  "Finding your birth location...",
  "Computing planetary longitudes...",
  "Building Bhinnashtakvarga tables...",
  "Calculating Sarvashtakvarga...",
];

export const STEP_DELAY_MS = 1200;

export const STRENGTH_CONFIG = {
  very_strong: {
    label: "Very Strong",
    color: "var(--color-success, #2a7a4b)",
    bg: "rgba(42,122,75,0.08)",
  },
  average: { label: "Average", color: "var(--ish-accent)", bg: "var(--ish-accent-light)" },
  below_average: { label: "Below Average", color: "#b07c00", bg: "rgba(176,124,0,0.08)" },
  weak: { label: "Weak", color: "#c0392b", bg: "rgba(192,57,43,0.08)" },
};

export const PLANET_ORDER = ["sun", "moon", "mars", "mercury", "jupiter", "venus", "saturn"];
